import * as React from "react";

/**
 * شريط تحكّم الفيديو الموحَّد لكلّ فيديوهات الموقع (هيرو + بلوكات الهوم + الصفحات).
 * القاعدة: زرّ التشغيل أوّلاً ثمّ زرّ الصوت، أفقياً، أسفل اليسار دائماً (LTR)
 * حتى لا يتعارض مع زرّ واتساب/الشات أسفل اليمين.
 */
export function VideoControlsBar({
  children,
  size = "md",
}: {
  children: React.ReactNode;
  size?: "sm" | "md";
}) {
  return (
    <div
      dir="ltr"
      style={{ direction: "ltr" }}
      className={`pointer-events-none absolute bottom-56 left-4 z-50 flex items-center md:bottom-40 ${
        size === "sm" ? "gap-1.5" : "gap-2"
      }`}
    >
      {children}
    </div>
  );
}

export function videoControlButtonClass(size: "sm" | "md" = "md") {
  const box = size === "sm" ? "h-9 w-9" : "h-11 w-11";
  return `pointer-events-auto inline-flex ${box} items-center justify-center rounded-full border border-white/50 bg-black/60 text-white backdrop-blur-md transition-colors hover:bg-black/80 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary`;
}

export function videoControlIconClass(size: "sm" | "md" = "md") {
  return size === "sm" ? "h-4 w-4" : "h-5 w-5";
}
